












import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import { OverviewLayoutITF } from '@/interfaces';
import FieldDefs from './FieldDefs';

@Component
export default class ManageApieventsOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;

  public async deleteAll() {
    await this.api.postAction(this.$store, '/apievents/clear');
    if (this.$refs.overview) {
      ((this.$refs.overview as unknown) as OverviewLayoutITF).tableUpdateData(true);
    }
  }
}
